import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';

@Component({
  selector: 'app-grs',
  templateUrl: './grs.component.html',
  styleUrls: ['./grs.component.css']
})
export class GrsComponent implements OnInit {

  form1: boolean = false;
  form2: boolean = false;
  form3: boolean = false;
  formDetail3: boolean = false;

  selectedGroup: any;

  trades: any = ['trade 11', 'trade 12', 'trade 13'];
  singlerollnoval: any = ['11111', '222222', '33333'];

  groups = [
    {
      id: 1,
      name: 'Payment done but not updated',
      items: 'red pencil',
    },
    {
      id: 2,
      name: 'Duplicate payments / Refund Issue',
      items: 'big rubber',
    },
    {
      id: 3,
      name: 'Exam related Issue',
      items: 'big pen',
    },
  ];



  getVal() {
    if (this.selectedGroup.name == 'Payment done but not updated') {
      this.form1 = true;
      this.form2 = false;
      this.form3 = false;
      this.onLoginReset();
      this.examFormloginBoolean = true;
      this.examFormBoolean = false;
    } else if (this.selectedGroup.name == 'Duplicate payments / Refund Issue') {
      this.form1 = false;
      this.form2 = true;
      this.form3 = false;
      this.onLoginReset();
      this.examFormloginBoolean = true;
      this.examFormBoolean = false;
    } else if (this.selectedGroup.name == 'Exam related Issue') {
      this.form1 = false;
      this.form2 = false;
      this.form3 = true;
      this.formDetail3 = true;
      this.onLoginReset();
      this.examFormloginBoolean = true;
      this.examFormBoolean = false;
    }
    // console.log(this.selectedGroup); // returns selected object
    // console.log(this.selectedGroup.id); // returns selected option's id
    // console.log(this.selectedGroup.name); // returns selected option's name
  }

  bdnuForm: any;
  registerForms: any;

  loginForm: any;
  eriForm: any;

  submitted = false;

  cities: any = {};

  countries = [
    {
      id: 1,
      cities: ['iticode 11', 'iticode 12', 'iticode 13'],
    },
    {
      id: 2,
      cities: ['iticode 21', 'iticode 22', 'iticode 23'],
    },
    {
      id: 3,
      cities: ['iticode 31', 'iticode 32', 'iticode 33'],
    },
  ];

  ntefSub: any = {};
  ntefsub_bool: boolean = false;
  ntefdesc_bool: boolean = false;
  ntefmain_bool: boolean = false;

  NTEF = [
    {
      id: 1,
      name: 'Exam Incomplete',
      ntefSub: ['Internet Failure during Exam', 'Power Failure During Exam', 'Question and Images not loaded properly', 'Submission Error'],

    },
    {
      id: 2,
      name: 'Student Absent',
      ntefSub: ['Hall Ticket Issues', 'Came Late'],
    },
    {
      id: 3,
      name: 'Student Present - Unable to attend the Exam',
      ntefSub: ['Total Power Failure', 'Total Internet Breakdown', 'Attendance app did not work', 'SEB Issue', 'Computer Systems Failure'],
    },
    {
      id: 4,
      name: 'Others'
    }
  ];


  ntefonChange(event: any) {
    var ntef_val = event.target.value;
    this.ntefSub = this.NTEF.filter(x => x.name == ntef_val)[0].ntefSub;
    this.ntefsub_bool = true;

    if (event.target.value == 'Others') {

      this.ntefsub_bool = false;
      this.ntefdesc_bool = true;
      this.eriForm.get('issuedetail').clearValidators();
      this.eriForm.get('issuedetail').value = '';
      this.eriForm.get('issuedetail').updateValueAndValidity();

      this.eriForm.get('description').setValidators([Validators.required]);

    }
    else {

      this.ntefdesc_bool = false;
      this.eriForm.get('description').clearValidators();
      this.eriForm.get('description').value = '';
      this.eriForm.get('description').updateValueAndValidity();

      this.eriForm.get('issuedetail').setValidators([Validators.required]);
    }
  }

  public state: any;
  public district: any;


  public eri_username: any;
  public eri_examdate: any;
  public eri_attendance: any;
  public eri_cenername: any;
  public eri_examstatus: any;
  public eri_shift: any;
  public eri_email: any;
  public eri_genrateid: any;
  public bool_eri_result: boolean = false;
  // public genrateid:any = "ERI210000";

  onChange(data: any) {
    var deviceValue = data.target.value;
    this.cities = this.countries.filter((x) => x.id == deviceValue)[0].cities;
  }

  onChangeState(data: any) {
    //console.log(data.target.value);
    var myargs = {
      stateName: data.target.value
    }
    this.api.enterState(myargs).subscribe((result: any) => {
      //console.log(JSON.stringify(result));
      this.district = result;
    });
  }

  tradeChange(data: any) {

    //console.log(data.target.value);
    var myargs = {
      tradeName: data.target.value
    };

    this.api.enterEriTrade(myargs).subscribe((result: any) => {
      //console.log(result);
      this.eriregno_single = result;
    });
  }

  rollnochange(data: any) {
    //console.log(data.target.value);
    var myargs = {
      rollNo: data.target.value
    };

    this.api.enterEriRollno(myargs).subscribe((result: any) => {
      console.log("Roll no: " + JSON.stringify(result));

      console.log(result[0]['username']);

      this.eri_username = result[0]['username'];
      this.eri_examdate = result[0]['examdate'];
      this.eri_shift = result[0]['Shift'];
      this.eri_attendance = result[0]['attendance'];
      this.eri_cenername = result[0]['cenername'];
      this.eri_examstatus = result[0]['examstatus'];
      this.eri_email = result[0]['email'];

      this.ntefmain_bool = true;

      //[{"username":"RAMESH KUMAR","examdate":"29-01-2021","attendance":"Present/9805903461/Q/2021-01-29 10:41:42","cenername":"GR02000207-Govt. ITI Rajgarh, Rajgarh, SIRMAUR, HIMACHAL PRADESH, -173101","examstatus":"submitted"}]
    });
  }


  onChangeDistrict(data: any) {
    //console.log("test");
  }

  public readioSelected: any;
  showcontent_cls: boolean = false;
  showbtn_value: any;
  public bulk_bool = false;
  public single_bool = false;

  showContent(event: any) {
    //this.formArr.removeAt(0);
    this.showbtn_value = event;
    if (event == 'radio1') {
      this.bulk_bool = true;
      this.single_bool = false;
      // this.registerForm.controls["singlerollno"].clearValidators();

      this.bdnuForm.get('singlerollno').clearValidators();
      this.bdnuForm.get('singlerollno').value = '';
      this.bdnuForm.get('singlerollno').updateValueAndValidity();
      this.bdnuForm.get('numberofstud').setValidators([Validators.required]);
      this.bdnuForm.get('amount').setValidators([Validators.required]);
      //this.registerForm.get('singlerollno').clearValidators();
    } else {
      this.bulk_bool = false;
      this.single_bool = true;
      this.bdnuForm.get('numberofstud').clearValidators();
      this.bdnuForm.get('numberofstud').value = '';
      this.bdnuForm.get('numberofstud').updateValueAndValidity();
      this.bdnuForm.get('amount').clearValidators();
      this.bdnuForm.get('amount').value = '';
      this.bdnuForm.get('amount').updateValueAndValidity();
      this.bdnuForm
        .get('singlerollno')
        .setValidators([Validators.required]);
    }

    this.showcontent_cls = this.readioSelected;
  }

  //convenience getter for easy access to form fields
  get f() {
    return this.bdnuForm.controls;
  }

  get l() {
    return this.loginForm.controls;
  }

  get eri() {
    return this.eriForm.controls;
  }

  onSubmit() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.bdnuForm.invalid) {
      return;
    }

    alert("SUCESS");
    console.log(this.bdnuForm.value);
    this.api
      .insertbdnuForm(this.bdnuForm.value)
      .subscribe((result: any) => {
        console.log("bdnu: " + result);
      });
  }

  onERISubmit() {
    this.submitted = true;


    var eri_regno = {
      regno: this.eriForm.value.regno
    };

    this.api.checkLeriregno(eri_regno).subscribe((result: any) => {
      // console.log(result);

      var check_regno = result.regno;
      if (this.eriForm.value.regno == check_regno) {
        alert("Grievance already raised for this Regiteration Number: " + check_regno);
        return;
      }
      else {
        // stop here if form is invalid
        if (this.eriForm.invalid) {
          return;
        }

        //alert("ERI Form created SUCESS");
        console.log(this.eriForm.value);
        this.api
          .insertEriForm(this.eriForm.value)
          .subscribe((result: any) => {
            this.eri_genrateid = result.refid;
            this.form3 = false;
            this.formDetail3 = true;
            this.bool_eri_result = true;
            //alert("your id no: " + result.refid);
          });
      }

    });


  }


  public state_single: any;
  public district_single: any;
  public iticode_single: any;
  public trade_single: any;
  public eriregno_single: any;
  public invigilator_name: any;
  public invigilator_role: any;

  public numberStud: any;
  onSubmitLogin() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.submitted = false;
    // this.bool_intruc_main = false;
    // this.bool_issue_type = true;
    //this.form3 = true;
    //this.formDetail3 = true;


    this.api
      .checkLogin(this.loginForm.value)
      .subscribe((result: any) => {

        var result_var = result['message'];
        console.log(result)

        if (result_var == 'No data Found') {
          alert("Please Login with valid Credentials");
          return;
        }
        {
          //alert("SUCESS");
          this.bool_intruc_main = false;
          this.bool_issue_type = true;
          this.form3 = true;
          this.formDetail3 = true;

          this.examFormloginBoolean = false;
          this.examFormBoolean = true;
          console.log(JSON.stringify(result));
          this.invigilator_name = result.name;
          this.invigilator_role = result.role;
          var eri = result;

          this.eriForm.state = result.State;

          this.state_single = result.State;
          this.district_single = result.district;
          this.iticode_single = result.iticode;

          //console.log(result.State);
          //console.log(result.district);
          //console.log(result.iticode);


          var eri_iticode = {
            iticode: result.iticode
          };

          //alert(JSON.stringify(eri_iticode));

          this.api.eriiticode(eri_iticode).subscribe((result: any) => {

            //console.log(result);
            this.trade_single = result;
            //console.log(this.trade_single);
            // for(var i=0;i< this.trade_single.length;i++){
            //   console.log(this.trade_single[i].trade);
            // }

          });


        }

      });




  }

  onReset() {
    this.submitted = false;
    this.bdnuForm.reset();
  }
  onLoginReset() {
    this.loginForm.reset();
    return;
  }

  constructor(private formBuilder: FormBuilder, private api: ApiService) { }


  ngOnInit(): void {
    this.api.liststate().subscribe((data: any) => {
      this.state = data;
      //console.log(data);
    });


    this.ntefSub = this.NTEF.filter(x => x.id == 1)[0].ntefSub;
    this.cities = this.countries.filter((x) => x.id == 1)[0].cities;

    this.bdnuForm = this.formBuilder.group({
      state: ['', Validators.required],
      district: ['', Validators.required],
      iticode: ['', Validators.required],
      trade: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      ccrefno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{12}$")]],
      orderid: [''],
      date: ['', Validators.required],
      radiobtn: ['', Validators.required],
      singlerollno: [''],
      numberofstud: [''],
      amount: [''],
      descreption: ['', [Validators.maxLength(500)]],
      acceptTerms: [false, Validators.requiredTrue],
    });

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
    });

    this.eriForm = this.formBuilder.group({
      // genrateid: ['ERI'],
      state: ['', Validators.required],
      district: ['', Validators.required],
      iticode: ['', Validators.required],
      trade: ['', Validators.required],
      regno: ['', Validators.required],
      username: ['', Validators.required],
      date: ['', Validators.required],
      shift: ['', Validators.required],
      attendance: ['', Validators.required],
      center: ['', Validators.required],
      status: ['', Validators.required],
      ntef: ['', Validators.required],
      issuedetail: [''],
      description: ['']

    });



  }

  public date = new Date().getDate();
  public month = new Date().getMonth() + 1;
  public year = new Date().getFullYear();
  public currentDate = this.date + '-' + this.month + '-' + this.year;

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    max: this.currentDate,
  };
  public examFormBoolean: boolean = false
  public examFormloginBoolean: boolean = false;


  login() {
    this.examFormloginBoolean = false;
    this.examFormBoolean = true;
  }

  public bool_instruction: boolean = true;
  public bool_issue_type: boolean = false;
  public bool_intruc_main: boolean = true;

  raisecomplaintfn() {
    this.bool_instruction = false;
    this.examFormloginBoolean = true;

  }

  complaint_fn(event: any) {


    if (event.target.value == 'pdu') {
      this.bool_intruc_main = false;
      this.bool_issue_type = true;
      this.form1 = true;
    }
    else if (event.target.value == 'dpr') {
      this.bool_intruc_main = false;
      this.bool_issue_type = true;
      this.form2 = true;
    }
    else if (event.target.value == 'eri') {
      this.bool_instruction = false;
      this.examFormloginBoolean = true;

      //this.form3 = true;
    }
  }
  grs_front_fn() {
    this.loginForm.reset();
    this.submitted = false;
    this.bool_eri_result = false;
    this.formDetail3 = false;
    this.bool_intruc_main = true;
    this.bool_instruction = true;
  }
  eri_again_fn() {
    this.bool_eri_result = false;
    this.form3 = true
    this.formDetail3 = true;
  }

  totAmount: any;
  onKey(event: any) {
    console.log(event.target.value);
    this.totAmount = event.target.value * 376;
  }


}
